
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ApiCaller } from '@frontend/api'
import type { Content } from '@types'
import { useMemo, useState } from 'react'

import Source from './Source'

import { useMessageContext } from '../../modules/Message'

export default function MessageSources() {
	const { message } = useMessageContext()

	const sources = message.sources ?? []
	const contents = message.contents ?? []

	const [showMore, setShowMore] = useState(false)

	function toggleExtraSources() {
		ApiCaller.track('Show_more_documents')
		setShowMore(!showMore)
	}

	const primaryContents = useMemo(
		() =>
			contents.reduce<Content[]>((prev, curr) => {
				const vectors = curr.vectors ?? []
				const contentVectorIds = vectors.map(vector => vector.id)

				const primarySource = sources.find(source => source.level === 'main' && contentVectorIds.includes(source.vectorId ?? ''))

				if (primarySource) {
					prev.push({
						...curr,
						index: primarySource.index
					})
				}

				return prev
			}, []).sort((a, b) => (a.index ?? 0) - (b.index ?? 0)),
		[contents, sources]
	)

	const secondaryContents = useMemo(() => contents.filter(content => !primaryContents.find(pc => pc.id === content.id)), [contents, primaryContents])

	if (!sources.length) {
		return null
	}

	const mainContentsAmount = primaryContents.length
	const secondaryContentsAmount = secondaryContents.length

	return (
		<div className='w-full'>
			<div className='flex items-center text-sm font-bold italic text-gray-500'>
				<FontAwesomeIcon icon='bookmark' className='mr-2 w-4 h-4' />
				<p>
					{ mainContentsAmount + secondaryContentsAmount } document{ (mainContentsAmount + secondaryContentsAmount) > 1 ? 's' : '' } shortlisted in this answer
				</p>
				<button className='ml-3 text-gray-400 text-sm font-normal hover:underline' onClick={ toggleExtraSources }>
					{ showMore ? 'hide (-)' : 'show (+)' }
				</button>
			</div>
			{
				showMore
					? <div className='mt-3 max-w-full'>
						{
							mainContentsAmount > 0 && (
								<div>
									<p className='text-sm italic text-gray-400 font-semibold mb-2'>
										Main documents used in this answer ({ mainContentsAmount })
									</p>
									<div className='grid grid-cols-4 gap-2 mb-4'>
										{
											primaryContents.map((content, index) => (
												<Source
													key={ index }
													content={ content }
													type='main'
												/>
											))
										}
									</div>
								</div>
							)
						}
						{
							secondaryContentsAmount > 0 && (
								<div>
									<p className='text-sm italic text-gray-400 font-semibold mb-2'>
										Related documents ({ secondaryContentsAmount })
									</p>
									<div className='flex flex-wrap max-w-full'>
										{
											secondaryContents.map((content, index) => (
												<Source
													key={ index }
													content={ content }
													type='secondary'
												/>
											))
										}
									</div>
								</div>
							)
						}
					</div>
					: null
			}
		</div>
	)
}
